export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/vacation.36fff77.svg";